import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { useAdminContext } from '../../../context/adminContext';
import { getAllTransfersApi, updateTransferStatusApi, } from '../../../utils/ApiEndpointFunctions';
import Header from '../../common/Header';
import toast from "react-hot-toast";
import Pagination from '../../common/Pagination';
import Spinwheel from '../../common/Spinwheel';
import moment from 'moment';
import ViewTransactionModel from './ViewTransactionModel';

function Transfer() {
  const [tableSpin, setTableSpin] = useState(true);
  const [transfers, setTransfers] = useState([]);
  const [markTransfer, setMarkTransfer] = useState({ status: false, _id: null, actionStatus: "" })
  const [selectRow, setSelectRow] = useState({})
  let [selectedPage, setSelectPage] = useState(0);
  const [page, setPage] = useState(0);
  const limit = 10;
  const transferModalId = "transferModalId"
  const viewModelId = "viewModelId"
  const navigate = useNavigate();


  const getTransferList = async (selectedPage) => {
    try {
      setTableSpin(false)
      const res = await getAllTransfersApi("", limit, selectedPage + 1)
      if (res.status === 200) {
        setTransfers(res.data?.data?.data)
        const totaldata = res.data?.data?.totalData

        setPage(Math.ceil(totaldata / limit));
      }
      setTableSpin(true)
    } catch (error) {
      setTableSpin(true)
    }
  }


  const handleConfirmation = async () => {
    setMarkTransfer({ ...markTransfer, status: true })
    try {
      const res = await updateTransferStatusApi({ _id: markTransfer?._id, status: markTransfer.actionStatus })
      if (res.status == 200) {
        getTransferList(selectedPage)
        toast.success(res.data?.message);
      }
      setMarkTransfer({ _id: null, status: false })
      document.getElementById(transferModalId).click()
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.message || "Failed to update status")
      setMarkTransfer({ _id: null, status: false })
      document.getElementById(transferModalId).click()
    }

  }

  const handlePageClick = (event) => {
    setSelectPage(event.selected);
    getTransferList(event.selected)
  };


  useEffect(() => {
    getTransferList(selectedPage)
  }, [])


  return (
    <>
      {/*<Sidebar />*/}
      <div className="main-content vh-100 vh_md-auto overflow-y-a">
        <Header title="Money changer" />
        {/* CARDS */}
        <div className="container-fluid">
          <div className="row">
            <nav className="mb-5">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">
                    <i className="fe fe-home"></i> Dashboard
                  </Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Money changer
                </li>
              </ol>
            </nav>
            <div className="mb-4" style={{ textAlign: "end" }}>
              <div className='d-flex justify-content-end gap-2' style={{ display: "-webkit-inline-box" }}>

                <button className="btn-custom w-auto" onClick={() => { navigate("rate") }} >Manage rate </button>

              </div>
            </div>
            <hr />

            <div className="card p-3 table-responsive" >
              <table className="table table-hover table-nowrap card-table">
                <thead>
                  <tr>
                    <th>
                      <span
                        className="list-sort text-muted"
                      >
                        S.No
                      </span>
                    </th>
                    <th>
                      <span className="list-sort text-muted">
                        Transaction ID
                      </span>
                    </th>
                    <th>
                      <span
                        className="list-sort text-muted"
                      >
                        From
                      </span>
                    </th>
                    <th>
                      <span
                        className="list-sort text-muted"
                      >
                        To
                      </span>
                    </th>
                    <th>
                      <span
                        className="list-sort text-muted"
                      >
                        Account(To)
                      </span>
                    </th>
                    <th>
                      <span
                        className="list-sort text-muted"
                      >
                        Bank(To)
                      </span>
                    </th>
                    <th>
                      <span
                        className="list-sort text-muted"
                      >
                        Received amount
                      </span>
                    </th>

                    <th>
                      <span
                        className="list-sort text-muted"
                      >
                        Exchange Amount
                      </span>
                    </th>

                    <th>
                      <span
                        className="list-sort text-muted"
                      >
                        Paid On
                      </span>
                    </th>
                    <th>
                      <span
                        className="list-sort text-muted"
                      >
                        Received On
                      </span>
                    </th>
                    <th>
                      <span
                        className="list-sort text-muted"
                      >
                        Remark
                      </span>
                    </th>
                    <th colSpan={2}>
                      <span
                        className="list-sort text-muted"
                      >
                        status
                      </span>
                    </th>
                  </tr>
                </thead>
                {
                  tableSpin ?
                    <tbody className="list fs-base">
                      {transfers?.length > 0 ? transfers?.map((ele, index) => {
                        return (<tr key={index} >
                          <td>{index + 1}</td>
                          <td>{ele?.invoiceNo ? ele.invoiceNo : "-"}</td>
                          <td>
                            <div>
                              {ele?.name ? ele?.name : "-"}
                            </div>
                          </td>
                          <td>
                            <span
                              className="item-phone text-reset"
                            >
                              {ele?.receiverName ? ele?.receiverName : "-"}
                            </span>
                          </td>
                          <td>
                            <span
                              className="item-phone text-reset"
                            >
                              {ele?.receiverAccountNo ? ele?.receiverAccountNo : "-"}
                            </span>
                          </td>

                          <td className='position-relative'>
                            <span
                              className="item-name text-reset"
                            >
                              {ele?.receiverBank ? (
                                <div className="tooltip1">
                                  {ele?.receiverBank?.substr(0, 20)}...
                                  <div className='wrapper'>
                                    <div className="tooltip1-text">{ele?.receiverBank}</div>
                                  </div>
                                </div>
                              ) : (
                                "-"
                              )}
                            </span>
                          </td>
                          <td>
                            <span
                              className="item-phone text-reset"
                            >
                              {ele?.currencyAmt ? ele?.currencyAmt : "-"}
                            </span>
                          </td>

                          <td>
                            <span
                              className="item-phone text-reset"
                            >
                              {ele?.exchangeAmt ? ele?.exchangeAmt : "-"}
                            </span>
                          </td>
                          <td>
                            <span
                              className="item-phone text-reset"
                            >
                              {ele?.paidOn ? moment(ele?.paidOn).format("DD/MM/YYYY") : "-"}
                            </span>
                          </td>
                          <td>
                            <span
                              className="item-phone text-reset"
                            >
                              {ele?.receivedOn ? moment(ele?.receivedOn).format("DD/MM/YYYY") : "-"}
                            </span>
                          </td>
                          <td className='position-relative'>
                            <span
                              className="item-name text-reset"
                            >
                              {ele?.remark ? (
                                <div className="tooltip1">
                                  {ele?.remark?.substr(0, 20)}...
                                  <div className='wrapper'>
                                    <div className="tooltip1-text">{ele?.remark}</div>
                                  </div>
                                </div>
                              ) : (
                                "-"
                              )}
                            </span>
                          </td>
                          <td>
                            <span
                              className="item-phone text-reset"
                            >
                              <div className={`badge ${ele?.status == "transferred" ? "badge bg-success-soft" : "bg-dark-soft"} `}>
                                {ele?.status}
                              </div>
                            </span>
                          </td>


                          <td className="text-end">

                            <div className="dropdown">
                              <span
                                className="dropdown-ellipses dropdown-toggle"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                <i className="fe fe-more-vertical" />
                              </span>
                              <div className="dropdown-menu ">
                                <div data-bs-toggle="modal" data-bs-target={`#${viewModelId}`} className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => { setSelectRow(ele); }}  >
                                  View
                                </div>

                                {ele?.status?.toLowerCase() == "issued" &&
                                  <div data-bs-toggle="modal" data-bs-target={`#${transferModalId}`} className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => { setMarkTransfer({ ...markTransfer, _id: ele?._id, actionStatus: "received" }); }}  >
                                    Mark as received
                                  </div>
                                }

                                {ele?.status?.toLowerCase() == "received" &&
                                  <div data-bs-toggle="modal" data-bs-target={`#${transferModalId}`} className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => { setMarkTransfer({ ...markTransfer, _id: ele?._id, actionStatus: "transferred" }); }}  >
                                    Mark as transferred
                                  </div>
                                }
                              </div>
                            </div>

                          </td>
                        </tr>
                        )
                      }) : <tr align="center">
                        <td colSpan="12">
                          <h1>
                            Data Not Found
                          </h1>
                        </td>
                      </tr>}
                    </tbody> : (
                      <tbody>
                        <tr align="center">
                          <td colSpan="9">
                            <Spinwheel />
                          </td>
                        </tr>
                      </tbody>
                    )
                }
              </table>
            </div>
            <div className="d-flex justify-content-center">
              {transfers?.length > 0 ? <Pagination
                clickHandler={handlePageClick}
                page={page}
                selectedPage={selectedPage}
              />
                : null}
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id={transferModalId} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-sm modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button type="button" className="btn-close block-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body pe-0 ps-0 block-user">
              <img src="/images/blockuser.png" alt="" width={202} srcSet="" />
              <h1 className="mb-0">Are you sure you want to<br /> mark as {markTransfer.actionStatus} ?</h1>
            </div>
            <div className="modal-footer pe-0 ps-0 border-0 justify-content-center pt-0 mb-3">
              <button type="button" className="btn-custom w-auto" disabled={markTransfer?.status} onClick={handleConfirmation} >YES</button>
              <button type="button" className="btn-custom w-auto mt-2" disabled={markTransfer?.status} data-bs-dismiss={`${markTransfer?.status ? "" : "modal"}`} >
                NO
              </button>
            </div>
          </div>
        </div>
      </div>

      <ViewTransactionModel modalId={viewModelId} id={markTransfer?._id} data={selectRow} />
    </>
  )
}

export default Transfer